import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetPowerSellerRequestService = (page = 1, limit = 10, type?: string) => {
  return HTTP_CLIENT.get(
    `${
      Endpoint.powerSellerRequests.getPowerSellerRequests
    }?page=${page}&limit=${limit}${type ? `&type=${type}` : ""}`
  );
};

const VerifyPowerSellerService = (id: number, payload: any) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.powerSellerRequests.verifyPowerSeller}/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export { GetPowerSellerRequestService, VerifyPowerSellerService };
